// Utility for SEO Analysis

export const analyzeSEO = (content, keyword) => {
    if (!content) return { words: 0, density: 0, score: 0, issues: [] };
  
    // Strip HTML tags for counting
    const text = content.replace(/<[^>]*>?/gm, " ");
    const words = text.trim().split(/\s+/).filter(w => w.length > 0);
    const wordCount = words.length;
  
    let density = 0;
    let score = 0;
    const issues = [];
  
    // Keyword Analysis
    if (keyword && keyword.trim() !== '') {
      const lowerText = text.toLowerCase();
      const lowerKeyword = keyword.toLowerCase();
      const matches = (lowerText.match(new RegExp(lowerKeyword, "g")) || []).length;
      
      density = (matches / wordCount) * 100;
      
      // Scoring Logic
      if (density >= 0.5 && density <= 2.5) {
        score += 30;
      } else if (density > 2.5) {
        issues.push('Keyword stuffing detected (> 2.5%)');
        score += 10;
      } else {
        issues.push('Keyword density too low (< 0.5%)');
        score += 10;
      }
  
      if (matches > 0) score += 10; // At least appears once
    } else {
      issues.push('No focus keyword set');
    }
  
    // Length Analysis
    if (wordCount > 300) {
      score += 40;
    } else if (wordCount > 100) {
      score += 20;
      issues.push('Content is a bit short (< 300 words)');
    } else {
      issues.push('Content is too short (< 100 words)');
    }
  
    return {
      words: wordCount,
      density: density.toFixed(2),
      score: Math.min(100, score),
      issues
    };
  };